import { FC, useState } from 'react';
import cx from 'classnames';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { useCopyToClipboard } from '@/hooks';

import styles from './CopyText.module.sass';

interface CopyTextProps {
  text: string;
  copyText?: string;
  className?: string;
}

const CopyText: FC<CopyTextProps> = (props) => {
  const { text, copyText = text, className = '' } = props;
  const [copied, setCopied] = useState(false);
  const [, copy] = useCopyToClipboard(false);

  const handleCopy = async () => {
    try {
      const success = await copy(copyText);
      setCopied(success);
      if (success) {
        setTimeout(() => setCopied(false), 2000);
      }
    } catch (error: unknown) {
      console.log('Unexpected:', error);
    }
  };

  const copyTextClassName = cx(styles.copyTextComponent, className, {
    [styles.copied]: copied,
  });

  const checkIconClassName = cx(styles.icon, styles.iconCheck);
  const copyIconClassName = cx(styles.icon, styles.iconCopy);

  if (!text) {
    return null;
  }

  return (
    <span className={copyTextClassName} onClick={handleCopy}>
      <span className={styles.text}>{text}</span>
      {copied ? (
        <CheckOutlined className={checkIconClassName} />
      ) : (
        <CopyOutlined className={copyIconClassName} />
      )}
    </span>
  );
};

export default CopyText;
